module.exports = __webpack_public_path__ + "static/media/fcc.b240e629.jfif";